export default function capitalize(words = '', all = true) {
  return words
    .split(' ')
    .map((word, i) =>
      i === 0 || all ? word.charAt(0).toUpperCase() + word.substring(1) : word
    )
    .join(' ');
}
